<template>
  <div>
    <bar
      :chart-options="chartOptions"
      :chart-data="chartData"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartJSPluginDatalabels
)

export default {
  name: 'ModalAttendanceStatisticEmployees',
  components: {
    Bar
  },
  props: {
    attendanceType: {
      type: Array,
      default: () => []
    },
    attendanceDataPerMonth: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      attendanceData: [],
      dataSet: [],
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Attendance',
            backgroundColor: '#ffc107',
            data: []
          }
        ]
      },
      titleText: 'Monthly Attendance',
      chartOptions: {
        responsive: true,
        tooltips: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: {
            type: 'category'
          },
          yAxes: {
            title: {
              display: true,
              text: 'Value'
            },
            ticks: {
              beginAtZero: true,
              stepSize: 2
            }
          }
        },
        plugins: {
          legend: {
            display: true,
            position: 'bottom'
          },
          title: {
            display: true,
            text: () => this.titleText,
            position: 'top'
          },
          aspectRatio: 4 / 3,
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value, ctx) => {
              return Math.round(value)
            },
            color: '#000000',
            font: {
              weight: 'bold'
            }
          }
        }
      }
    }
  },
  watch: {
    attendanceType: {
      handler() {
        this.attendanceType.forEach(type => {
          if (type.name !== 'Hadir') {
            this.chartData.labels.push(type.name)
            this.dataSet.push({
              attendaceTypeId: type.id,
              statement: type.name,
              total: 0
            })
          }
        })
      },
      immediate: true
    },
    attendanceDataPerMonth: {
      handler() {
        this.attendanceDataPerMonth.forEach(item => {
          this.attendanceData.push(item)
        })
      },
      immediate: true
    },
    attendanceData: {
      handler() {
        this.dataSet.forEach(item => {
          item.total = this.countTypeAttendanceById(item.attendaceTypeId)
        })
        this.chartData.datasets[0].data = this.dataSet.map(item => item.total)
      },
      deep: true
    }
  },
  methods: {
    setValueDateSet() {
      this.dataSet.forEach(item => {
        item.total = this.countTypeAttendanceById(item.attendaceTypeId)
      })
      this.chartData.datasets[0].data = this.dataSet.map(item => item.total)
    },
    countTypeAttendanceById(id) {
      let count = 0
      this.attendanceData.forEach(item => {
        if (id === item.attendanceTypeId) {
          count++
        }
      })
      return count
    },
    charDataShow() {
      this.dataSet.forEach(item => {
        item.total = this.countTypeAttendanceById(item.attendaceTypeId)
      })
      this.chartData.datasets[0].data = this.dataSet.map(item => item.total)
    }
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.help-button{
  border: 1px solid rgb(126, 125, 125);
}

.button-select-month{
  width: 20vh;
}
</style>
